export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 10) {
    return phone;
  }

  const ddd = digits.slice(0, 2);
  const first = digits[2];
  const last4 = digits.slice(-4);
  return `(${ddd}) ${first}••••-${last4}`;
}

export function maskEmail(email: string): string {
  const separator = email.lastIndexOf("@");
  if (separator <= 0) {
    return email;
  }

  const local = email.slice(0, separator);
  const domain = email.slice(separator + 1);
  const first = local[0] ?? "";
  return `${first}•••@${domain}`;
}
